import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PDFExportOptions } from "./pdf-export.model";

@Component({
	selector: 'lb-export-dialog',
	templateUrl: './export-dialog.component.html',
	styleUrls: ['./export-dialog.component.css'],
})
export class ExportDialogComponent implements OnInit {
	@Input() exportMessage = '';
	@Input() loading = false;
	@Input() showCSVOption = false;

	@Output() exportToPDFClicked = new EventEmitter<PDFExportOptions>();
	@Output() exportToCSVClicked = new EventEmitter<boolean>();

	exportType: 'pdf' | 'csv' = 'pdf';
	pdfExportOptions = new PDFExportOptions();
	
	constructor() { }

	ngOnInit() {}

	onExportToPDFClicked() {
		this.exportToPDFClicked.emit(this.pdfExportOptions);

		this.showExportDialog = false;
	}

	onExportToCSVClicked() {
		this.exportToCSVClicked.emit(this.pdfExportOptions.showComments);

		this.showExportDialog = false;
	}

	// TODO: When note-detail is an ng component, replace these bindings with a template reference variable
	// that changes dialog visibility from parent component templates
	private _showExportDialog = false;
	@Input()
	get showExportDialog() {
		return this._showExportDialog;
	}
	set showExportDialog(val) {
		this._showExportDialog = val;
		this.showExportDialogChange.emit(val);
	}
	@Output() showExportDialogChange = new EventEmitter<boolean>();
}